/**
 * Возвращает полный URL изображения.
 * Если path уже полный URL (http/https/data:) — возвращает как есть.
 * Иначе добавляет REACT_APP_STORAGE_URL.
 */
export default function getImageUrl(path, defaultImg) {
  if (!path) return defaultImg ?? null;
  if (
    typeof path === "string" &&
    (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("data:"))
  ) {
    return path;
  }
  return process.env.REACT_APP_STORAGE_URL + path;
}
